/**
 * VendorProductAddOnCategoryService
 * Service for managing vendor product add-on categories with view endpoints
 */
import { CrudService } from '../base/CrudService';
/**
 * Service for vendor product add-on category CRUD operations with view endpoints
 */
export class VendorProductAddOnCategoryService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? VendorProductAddOnCategoryService.DEFAULT_SERVICE_PATH,
            basePath: VendorProductAddOnCategoryService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    /**
     * Get all add-on category views
     * @returns Array of add-on category model views
     */
    async getViews() {
        const response = await this.getViewsRaw();
        return response.data ?? [];
    }
    /**
     * Get all add-on category views with full response
     * @returns ResponseData with array of add-on category model views
     */
    getViewsRaw() {
        const url = this.buildUrl('views');
        return this.http.get(url);
    }
    /**
     * Get add-on category view by ID
     * @param id - Category ID
     * @returns Add-on category model view
     */
    async getView(id) {
        const response = await this.getViewRaw(id);
        if (!response.data) {
            throw new Error(`Vendor product add-on category view with ID ${id} not found`);
        }
        return response.data;
    }
    /**
     * Get add-on category view by ID with full response
     * @param id - Category ID
     * @returns ResponseData with add-on category model view
     */
    getViewRaw(id) {
        const url = this.buildUrl(`${id}/view`);
        return this.http.get(url);
    }
    /**
     * Get add-on category views by vendor ID
     * @param vendorId - Vendor ID
     * @returns Array of add-on category model views for the vendor
     */
    async getByVendorId(vendorId) {
        const response = await this.getByVendorIdRaw(vendorId);
        return response.data ?? [];
    }
    /**
     * Get add-on category views by vendor ID with full response
     * @param vendorId - Vendor ID
     * @returns ResponseData with array of add-on category model views
     */
    getByVendorIdRaw(vendorId) {
        const url = this.buildUrl(`by-vendor/${vendorId}/views`);
        return this.http.get(url);
    }
}
VendorProductAddOnCategoryService.DEFAULT_SERVICE_PATH = 'vendor-catalogs';
VendorProductAddOnCategoryService.BASE_PATH = 'api/vendor-product-add-on-categories';
//# sourceMappingURL=VendorProductAddOnCategoryService.js.map